import React, { useMemo } from "react";
import { getDpatQaMemoContent } from "../utils/dpatQaMemoTemplate";

function MemoHighlight({ children }) {
  return <span className="dpat-qa-memo-highlight">{children}</span>;
}

export default function DpatQaMemoTemplateView({ districtName, year, summary }) {
  const content = useMemo(
    () => getDpatQaMemoContent({ districtName, year, summary }),
    [districtName, year, summary]
  );

  return (
    <div className="dpat-qa-memo-document-root" data-qa-memo-template="true">
      <h2 className="dpat-qa-memo-title">
        <u>DPAT X PROVISIONAL RESULTS (MEMO)</u>
      </h2>

      <p className="dpat-qa-memo-line">
        This Memo provides a summary of the provisional results for{" "}
        <MemoHighlight>{content.districtName}</MemoHighlight> on its performance after the
        conduct of DPAT X ({content.assessmentYear}) assessment.
      </p>

      <p className="dpat-qa-memo-line">
        The Quality Assurance Review (QAR) Team after triangulating DDDP generated scores,
        Technical Team scores and other relevant documents,{" "}
        <MemoHighlight>{content.districtName}</MemoHighlight> scored{" "}
        <MemoHighlight>{content.overallScore}</MemoHighlight>.
      </p>

      <p className="dpat-qa-memo-line">
        Details of the results as per the DPAT Components are as follows:
      </p>

      {content.ciItems.length > 0 ? (
        <>
          <p className="dpat-qa-memo-line">Compliance Indicators:</p>
          {content.ciItems.map((item) => (
            <p key={item.no} className="dpat-qa-memo-line">
              <MemoHighlight>
                {item.no}: {item.status}
              </MemoHighlight>
            </p>
          ))}
        </>
      ) : (
        <p className="dpat-qa-memo-line">
          Compliance Indicators: <MemoHighlight>{content.ciSummary}</MemoHighlight>
        </p>
      )}

      <p className="dpat-qa-memo-line">
        Service Delivery Indicators: <MemoHighlight>{content.sdiScore}</MemoHighlight>
      </p>

      <p className="dpat-qa-memo-line">
        Performance Indicators: <MemoHighlight>{content.piScore}</MemoHighlight>
      </p>

      <p className="dpat-qa-memo-line">
        Bonus(es) awarded are part of the total score as indicated below.
      </p>
    </div>
  );
}
